module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_8011.677e39c1.png";